import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

const PARENT_IMG = "https://images.unsplash.com/photo-1617638436040-76505e75940f?auto=format&fit=crop&w=1200&q=80";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
      <div>
        <Badge variant="outline" className="mb-3">About QuadScrub</Badge>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-primary leading-tight">Built by parents, for parents.</h1>
        <p className="mt-5 text-muted-foreground leading-relaxed">
          QuadScrub started after our co-founder visited her daughter's freshman dorm and realized that a 19-year-old
          juggling four classes, a part-time job, and a social life shouldn't be expected to keep a textbook-clean room.
        </p>
        <p className="mt-3 text-muted-foreground leading-relaxed">
          We employ vetted, background-checked professionals who treat your student's room with care. Every cleaner is
          trained on our 38-point checklist and submits a full photo report after every visit — so you always know what
          you're paying for.
        </p>
        <div className="grid grid-cols-3 gap-6 mt-10">
          {[
            { n: "2021", l: "Founded" },
            { n: "60+", l: "Campuses served" },
            { n: "150+", l: "Cleaners on staff" },
          ].map((s) => (
            <div key={s.l}>
              <div className="font-display text-3xl font-bold text-primary">{s.n}</div>
              <div className="text-xs text-muted-foreground mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
      <Card className="overflow-hidden border-border/60">
        <img src={PARENT_IMG} alt="Parent & student" className="w-full h-[420px] object-cover" />
        <CardContent className="p-6 bg-muted/40">
          <div className="font-display font-semibold text-primary">Our promise</div>
          <p className="text-sm text-muted-foreground mt-1">
            If you're not delighted with a cleaning, we'll re-clean it for free or refund the visit. No questions asked.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
